// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__15iYu","cell":"ColumnAccessor_cell__3RTqs","firstCellAccent":"ColumnAccessor_firstCellAccent__AmXII"};